/**
 * Таджикский набор строк.
 */

import type { Strings } from './index';

export const tg: Strings = {
  login_title: 'Ворид ба CargoPASS',
  login_phone_label: 'Рақами телефон',
  login_code_request: 'Гирифтани рамз',
  login_code_label: 'Рамз аз паём',
  login_code_submit: 'Ворид шудан',
  login_failed: 'Ворид шудан муяссар нашуд. Бори дигар кӯшиш кунед.',
  works_title: 'Корҳо',
  works_more: 'Боз нишон додан',
  works_failed: 'Рӯйхатро бор кардан муяссар нашуд.',

  // Ключи блока `WEB-1.1`: оболочка кабинета, четыре состояния экрана, вторая
  // ветка входа и согласие с условиями. Юридического текста условий здесь нет
  // ни в одном виде — его пишет человек, а временная строка была бы заглушкой.
  login_channel_phone: 'Бо телефон',
  login_channel_email: 'Бо почтаи электронӣ',
  login_email_label: 'Нишонии почтаи электронӣ',
  login_terms_label: 'Шартҳои истифодаро қабул мекунам',
  company_switcher_label: 'Ширкат',
  language_label: 'Забон',
  state_loading: 'Бор шуда истодааст…',
  state_empty: 'Ҳоло чизе нест',
  state_error: 'Маълумотро гирифтан муяссар нашуд',
  state_no_access: 'Ин саҳифа барои шумо дастрас нест',
  no_membership_title: 'Шумо дар ҳеҷ ширкат узв нестед',
  no_membership_explain: 'Барои оғози кор ба ширкат ҳамроҳ шавед ё ширкати худро кушоед.',
  company_create_submit: 'Ширкат кушодан',
  company_name_label: 'Номи ширкат',
  company_form_type_label: 'Навъи ширкат',
  company_tax_id_label: 'Рақами бақайдгирӣ',
  company_legal_address_label: 'Нишонии ҳуқуқӣ',
  company_members_title: 'Ҳайати ширкат',
  not_found_title: 'Чунин саҳифа нест',

  // Ключи блока `WEB-1.2`: профиль пользователя, сотрудники, права, профиль
  // фирмы и документы. Подписи значений перечней собираются строителями ключа
  // из значения, пришедшего с сервера, и потому на экране литералом не стоят.
  profile_title: 'Профили ман',
  profile_sessions_title: 'Сеансҳои фаъол',
  profile_session_current: 'Сеанси ҷорӣ',
  profile_session_never_used: 'Ҳеҷ гоҳ истифода нашудааст',
  profile_session_terminate: 'Хотима додан',
  profile_channel_add: 'Илова кардани канали алоқа',
  profile_channel_code_request: 'Фиристодани рамз',
  profile_channel_confirm: 'Тасдиқи канал',
  members_title: 'Кормандон',
  members_invite: 'Даъват кардани корманд',
  invite_channel_phone: 'Бо телефон',
  invite_channel_email: 'Бо почта',
  invite_role_label: 'Нақш',
  invite_submit: 'Фиристодани даъватнома',
  invitations_title: 'Даъватномаҳо',
  invitation_revoke: 'Бекор кардан',
  invitation_resend: 'Боз фиристодан',
  rights_title: 'Ҳуқуқҳои корманд',
  rights_grants: 'Илова бар нақш дода шуда',
  rights_denies: 'Шахсан манъ шуда',
  rights_grant_add: 'Додани ҳуқуқ',
  rights_deny_add: 'Гузоштани манъ',
  rights_remove: 'Гирифтан',
  company_profile_title: 'Профили ширкат',
  company_documents_title: 'Ҳуҷҷатҳои ширкат',
  company_type_transport: 'Ҳамлкунанда',
  company_type_logistics: 'Ширкати логистикӣ',
  member_documents_title: 'Ҳуҷҷатҳои корманд',
  document_download: 'Кушодани файл',
  enum_unknown: 'Номаълум',
  role_director: 'Директор',
  role_logist: 'Логист',
  role_dispatcher: 'Диспетчер',
  role_accountant: 'Муҳосиб',
  role_mechanic: 'Механик',
  role_driver: 'Ронанда',
  member_status_active: 'Амал мекунад',
  member_status_closed: 'Пӯшида',
  permission_company_staff_manage: 'Идораи кормандон',
  permission_company_rights_manage: 'Идораи ҳуқуқҳо',
  permission_company_fleet_manage: 'Идораи автопарк',
  permission_company_fleet_repair: 'Қайди таъмир',
  permission_company_docs_manage: 'Идораи ҳуҷҷатҳо',
  permission_company_listings_manage: 'Идораи эълонҳо',
  permission_company_cargo_take: 'Гирифтани бор',
  // РОСТ 0.9.30 (BE-2.4, шаг CONTRACT; решение D525): восьмое право каталога — привязка транспорта и водителя.
  permission_company_works_assign: 'Таъин кардани нақлиёт ва ронанда',
  permission_company_accounting_manage: 'Пешбурди хароҷот ва пардохтҳои ширкат',
  document_status_pending: 'Дар санҷиш',
  document_status_verified: 'Тасдиқшуда',
  document_status_rejected: 'Радшуда',
  document_status_expired: 'Мӯҳлаташ гузашта',
  document_status_not_verified: 'Тасдиқнашуда',
  invitation_status_pending: 'Дар интизори ҷавоб',
  invitation_status_accepted: 'Қабул шуд',
  invitation_status_revoked: 'Бекор карда шуд',
  invitation_status_expired: 'Мӯҳлаташ гузашт',

  // Блок `WEB-1.3`. До волны 4 — машинный подстрочник (CR-008): присутствие и
  // непустота обязательны, содержимое проверке не подлежит.
  fleet_title: 'Нақлиёти ширкат',
  fleet_add: 'Илова кардани нақлиёт',
  fleet_vin: 'Рақами VIN',
  fleet_tech_passport: 'Рақами шиносномаи техникӣ',
  fleet_kind_label: 'Навъи нақлиёт',
  fleet_body_type_label: 'Навъи кузов',
  fleet_withdraw: 'Аз феҳрист баровардан',
  fleet_withdrawn_at: 'Санаи баровардан',
  fleet_empty: 'Феҳрист ҳоло холист',
  service_title: 'Хизматрасонии мошин',
  service_state_label: 'Ҳолати техникӣ',
  service_state_change: 'Гузарондани ҳолат',
  service_records_title: 'Дафтари корҳо',
  service_record_add: 'Сабт илова кардан',
  service_description: 'Чӣ кор карда шуд, кадом агрегатҳо',
  service_parts: 'Қисмҳои эҳтиётӣ',
  service_cost: 'Харҷ',
  service_currency: 'Асъор',
  service_records_empty: 'Ҳоло сабтҳо нестанд',
  vin_claims_title: 'Аризаҳо барои озод кардани VIN',
  vin_claim_create: 'Ариза додан',
  vin_claim_object: 'Эътироз кардан',
  vin_claim_window_ends_at: 'Тирезаи эътироз то',
  vin_claims_empty: 'Ҳоло аризаҳо нестанд',
  vehicle_kind_tractor: 'Кашанда',
  vehicle_kind_trailer: 'Ядак',
  body_type_tarpaulin: 'Тентдор',
  body_type_refrigerator: 'Яхдондор',
  body_type_isothermal: 'Изотермӣ',
  body_type_box: 'Фургони пӯшида',
  body_type_flatbed: 'Бортдор',
  body_type_platform: 'Майдончаи кушода',
  body_type_lowbed: 'Трали паст',
  body_type_mega: 'Кузови мега',
  body_type_car_carrier: 'Мошинкашон',
  body_type_tipper: 'Худрез',
  body_type_walking_floor: 'Фарши ҳаракаткунанда',
  body_type_tank: 'Систерна',
  body_type_silo: 'Силос-систерна',
  body_type_container_chassis: 'Шассии контейнерӣ',
  body_type_bdf: 'Кузови BDF',
  body_type_timber: 'Чӯбкашон',
  body_type_livestock: 'Чорвокашон',
  body_type_coil: 'Рулонкашон',
  body_type_heavy_haul: 'Бори вазнин',
  body_type_extendable: 'Дарозшаванда',
  repair_state_fault_detected: 'Носозӣ ошкор шуд',
  repair_state_in_repair: 'Дар таъмир',
  repair_state_repaired: 'Таъмир шуд',
  repair_state_ready: 'Тайёр ба кор',
  vehicle_status_active: 'Дар феҳрист',
  vehicle_status_withdrawn: 'Аз феҳрист бароварда шуд',
  vin_claim_status_pending: 'Тирезаи эътироз кушода',
  vin_claim_status_objected: 'Эътироз дода шуд',
  vin_claim_status_awaiting_admin: 'Мунтазири қарори кормандон',
  vin_claim_direction_outgoing: 'Аризаи мо',
  vin_claim_direction_incoming: 'Ариза ба мо',

  // Ключи блока `WEB-3.2` — страница публичного отслеживания по ссылке с PIN
  // (словарь §11 спецификации блока) и подписи двух перечней контракта.
  tracking_title: 'Пайгирии интиқоли мошин',
  tracking_pin_hint: 'PIN-и шашрақамаро, ки фармоишгар бо истинод додааст, ворид кунед. Бе PIN саҳифа чизе нишон намедиҳад.',
  tracking_pin_label: 'PIN-и шашрақама',
  tracking_pin_submit: 'Кушодан',
  tracking_offline: 'Пайваст нест. Интернетро санҷед ва бори дигар кӯшиш кунед.',
  tracking_offline_refresh: 'Пайваст нест — ҳангоми барқароршавии пайваст нав мешавад.',
  tracking_status_changed_at: 'Ҳолат иваз шуд',
  tracking_vehicle: 'Мошин',
  tracking_route: 'Масир',
  tracking_distance: 'Масофа',
  tracking_transit: 'Транзит',
  tracking_border_crossings: 'Шумораи убури сарҳад',
  tracking_last_position: 'Нуқтаи охирин',
  tracking_no_position: 'Ҷойгиршавӣ ҳоло гирифта нашудааст',
  tracking_open_map: 'Дар харита кушодан',
  tracking_photos: 'Қабули мошин',
  tracking_photo_open: 'Аксро кушодан',
  tracking_photo_plate: 'Рақами давлатӣ',
  tracking_photo_close: 'Пӯшидан',
  tracking_milestones: 'Марҳилаҳо',
  tracking_locked_title: 'Истинод муваққатан дастрас нест',
  tracking_retry: 'PIN-ро аз нав ворид кардан',
  tracking_gone_title: 'Истинод эътибор надорад',
  tracking_map_title: 'Харита: нуқтаи охирин',
  work_status_CREATED: 'Сохта шуд',
  work_status_ASSIGNED: 'Таъин шуд',
  work_status_ACCEPTED: 'Ба иҷро қабул шуд',
  work_status_AT_PICKUP: 'Дар боркунӣ',
  work_status_AT_HANDOVER: 'Қабули мошин',
  work_status_IN_TRANSIT: 'Дар роҳ',
  work_status_DELIVERED: 'Супорида шуд',
  work_status_COMPLETED: 'Анҷом ёфт',
  work_status_CANCELLED: 'Бекор шуд',
  work_status_ARCHIVED: 'Дар бойгонӣ',
  peregon_vehicle_kind_tractor: 'Тягач',
  peregon_vehicle_kind_tractor_with_trailer: 'Тягач бо тиркама',
  peregon_vehicle_kind_car: 'Мошини сабукрав',

  // Ключи блока `WEB-2.1` — кабинет логиста: «Мои объявления», форма
  // объявления, карточка с offer'ами и доской заказа (словарь §11
  // спецификации блока) и подписи девяти перечней контракта.
  // До волны 4 значения этого языка — подстрочник (CR-008).
  cargo_listings_title: 'Эълонҳои бор',
  cargo_listings_create: 'Эълон додан',
  cargo_listings_more: 'Боз нишон додан',
  cargo_listings_empty: 'Ҳоло эълон нест',
  cargo_listing_edit: 'Тағйир додан',
  cargo_listing_close: 'Пӯшидан',
  cargo_listing_close_confirm: 'Эълон пӯшида шавад? Эълони пӯшида ба лента барнамегардад.',
  cargo_listing_km: 'км',
  cargo_listing_kg: 'кг',
  cargo_listing_days: 'рӯз',
  cargo_listing_transit: 'Транзит',
  cargo_listing_borders: 'Гузариш аз сарҳад',
  cargo_listing_slots_free: 'Холӣ',
  cargo_listing_slots_of: 'аз',
  cargo_listing_fixed: 'Нарх собит',
  cargo_listing_payment: 'Пардохт',
  cargo_listing_form_title_new: 'Эълони нави бор',
  cargo_listing_form_title_edit: 'Тағйири эълони бор',
  cargo_listing_form_origin: 'Шаҳри боркунӣ',
  cargo_listing_form_destination: 'Шаҳри борфарорӣ',
  cargo_listing_form_city_search: 'Номи шаҳрро нависед',
  cargo_listing_form_loading_at: 'Санаи боркунӣ',
  cargo_listing_form_unload_by: 'Борфарорӣ то',
  cargo_listing_form_vehicles_count: 'Чанд мошин лозим',
  cargo_listing_form_cargo_type: 'Бор',
  cargo_listing_form_weight: 'Вазн ба як мошин, кг',
  cargo_listing_form_adr: 'Бори хатарнок (ADR)',
  cargo_listing_form_body_type: 'Навъи кузов',
  cargo_listing_form_body_subtype: 'Зернавъи кузов',
  cargo_listing_form_temperature_from: 'аз',
  cargo_listing_form_temperature_to: 'то',
  cargo_listing_form_price: 'Нарх барои як мошин',
  cargo_listing_form_currency: 'Асъор',
  cargo_listing_form_negotiable: 'Савдо мумкин',
  cargo_listing_form_payment_method: 'Тарзи пардохт',
  cargo_listing_form_payment_moment: 'Вақти пардохт',
  cargo_listing_form_deferral_days: 'Рӯзҳои мӯҳлат',
  cargo_listing_form_comment: 'Шарҳ',
  cargo_listing_form_submit: 'Нашр кардан',
  cargo_listing_form_save: 'Тағйиротро нигоҳ доштан',
  cargo_offers_title: 'Пешниҳодҳои боркашонҳо',
  cargo_offer_accept: 'Тасдиқ кардан',
  cargo_offer_decline: 'Рад кардан',
  cargo_offer_decline_confirm: 'Пешниҳод рад шавад? Боркашон радро мебинад.',
  cargo_offer_agrees: 'Ба шартҳои шумо розӣ',
  cargo_offer_counter: 'Нархи худро пешниҳод мекунад',
  cargo_offer_documents_verified: 'Ҳуҷҷатҳо санҷида шудаанд',
  cargo_offer_vehicles: 'Мошинҳо',
  cargo_offer_price: 'Нархи боркашон',
  cargo_offer_listing_price: 'Нархи эълон',
  cargo_offer_expires: 'Ҷавоб то',
  cargo_offer_more: 'Боз пешниҳодҳо',
  cargo_slots_title: 'Тахтаи фармоиш',
  cargo_slot_work: 'Кор',
  listing_status_OPEN: 'Кушода',
  listing_status_TAKEN: 'Ҳамаи мошинҳо ёфт шуданд',
  listing_status_CLOSED: 'Пӯшида',
  listing_status_CANCELLED: 'Бекор шуда',
  listing_status_PENDING_REVIEW: 'Дар санҷиш',
  listing_status_REJECTED: 'Рад шуда',
  cargo_offer_status_PENDING: 'Интизори қарор',
  cargo_offer_status_APPROVED: 'Тасдиқ шуда — интизори боркашон',
  cargo_offer_status_CONFIRMED: 'Боркашон тасдиқ кард',
  cargo_offer_status_REJECTED: 'Рад шуда',
  cargo_offer_status_WITHDRAWN: 'Боркашон бозхонд',
  cargo_offer_status_EXPIRED: 'Мӯҳлат гузашт',
  cargo_offer_status_SUPERSEDED: 'Мошини холӣ намонд',
  cargo_slot_status_OPEN: 'Холӣ',
  cargo_slot_status_RESERVED: 'Интизори тасдиқи боркашон',
  cargo_slot_status_TAKEN: 'Банд',
  cargo_slot_status_CANCELLED: 'Бекор шуда',
  currency_USD: 'USD ($)',
  currency_UZS: 'UZS (сӯм)',
  currency_EUR: 'EUR (€)',
  payment_method_cash: 'Нақд',
  payment_method_bank_transfer: 'Интиқол ба ҳисоб',
  payment_moment_prepayment: 'Пешпардохт',
  payment_moment_on_unloading: 'Ҳангоми борфарорӣ',
  payment_moment_deferred: 'Бо мӯҳлат',
  loading_type_rear: 'Аз қафо',
  loading_type_side: 'Аз паҳлӯ',
  loading_type_top: 'Аз боло',
  loading_type_full_uncover: 'Бо пурра кушодан',
  body_parameter_length_m: 'Дарозӣ, м',
  body_parameter_width_m: 'Паҳнӣ, м',
  body_parameter_height_m: 'Баландӣ, м',
  body_parameter_volume_m3: 'Ҳаҷм, м³',
  body_parameter_capacity_t: 'Борбардорӣ, т',
  body_parameter_loading_type: 'Тарзи боркунӣ',
  body_parameter_temperature: 'Ҳарорат, °C',
  body_parameter_cars_capacity: 'Ғунҷоиш, мошин',

  // Ключи блока `WEB-2.4`: карточка машины, водители фирмы, строки запчастей,
  // файл техпаспорта заявки, дата рождения и пол; подписи пола и типа документа.
  // До волны 4 — подстрочник (CR-008): проверке не подлежит.
  vehicle_card_title: 'Корти мошин',
  vehicle_photo_title: 'Аксҳои мошин',
  vehicle_photo_file: 'Аксро интихоб кунед',
  vehicle_photo_add: 'Илова кардани акс',
  vehicle_photo_delete: 'Нест кардан',
  vehicle_photo_delete_confirm: 'Ин акси мошинро нест кунем?',
  vehicle_photo_empty: 'Ҳоло акс нест',
  vehicle_fault_title: 'Носозиҳои кушода',
  vehicle_fault_empty: 'Носозии кушода нест',
  vehicle_fault_author_unknown: 'Муаллиф нишон дода нашудааст',
  vehicle_fault_comment: 'Мошин чӣ носозӣ дорад',
  vehicle_fault_photos: 'Аксҳои носозӣ',
  vehicle_fault_add: 'Сабти носозӣ',
  vehicle_fault_history: 'Ҳамаи носозиҳо',
  vehicle_fault_open: 'Кушода',
  vehicle_fault_closed: 'Пӯшида',
  vehicle_fault_history_empty: 'Мошин носозӣ надошт',
  drivers_title: 'Ронандагони ширкат',
  drivers_age: 'Синну сол:',
  drivers_name_unknown: 'Ном нишон дода нашудааст',
  drivers_not_specified: 'нишон дода нашудааст',
  drivers_self_reported: 'Ном, синну сол ва ҷинсро худи шахс нишон додааст',
  drivers_documents: 'Ҳуҷҷатҳо',
  drivers_empty: 'Ҳоло ронанда нест',
  service_part_add: 'Илова кардани сатр',
  service_part_remove: 'Хориҷ кардан',
  service_part_name: 'Номи қисми эҳтиётӣ',
  service_part_quantity: 'Миқдор',
  vin_claim_file_label: 'Файли шиносномаи техникӣ — акс ё PDF',
  vin_claim_file_link: 'Шиносномаи техникӣ',
  vin_claim_file_missing: 'Бе файл супорида шуд',
  profile_birth_date: 'Санаи таваллуд',
  profile_gender: 'Ҷинс',
  profile_gender_unspecified: 'Нишон дода нашудааст',
  profile_personal_note: 'Худи шахс нишон додааст',
  profile_personal_hint: 'Ба шумо намоён аст; ба аъзоёни ширкат — танҳо синну сол ва ҷинс',
  profile_personal_save: 'Нигоҳ доштан',
  gender_male: 'Мард',
  gender_female: 'Зан',
  document_type_passport: 'Шиноснома',
  document_type_driver_license: 'Шаҳодатномаи ронандагӣ',
  document_type_adr_certificate: 'Шаҳодатномаи ADR',
  document_type_professional_certificate: 'Шаҳодатномаи касбӣ',
  document_type_face_snapshot: 'Акси рӯй',
  document_type_tachograph_card: 'Корти тахограф',
  document_type_code95_card: 'Корти «Код 95»',
  document_type_visa: 'Раводид',
  document_type_registration_certificate: 'Шаҳодатномаи бақайдгирӣ',
  expenses_title: 'Хароҷот',
  expenses_create: 'Сабти хароҷот',
  expenses_delete_confirm: 'Ин хароҷотро нест кунед?',
  expenses_empty: 'Ҳоло хароҷот нест',
  expense_form_submit: 'Нигоҳ доштани хароҷот',
  expense_form_category: 'Категория',
  expense_form_spent_on: 'Санаи хароҷот',
  expense_form_vehicle: 'Мошин',
  expense_form_receipt: 'Чек — акс ё PDF',
  expense_receipt_refreshed: 'Пайванди чек нав шуд — бори дигар кушоед',
  expense_receipt_replace_hint: 'файли нав ҷои пештараро мегирад',
  payouts_title: 'Пардохтҳо',
  payouts_create: 'Сабти пардохт',
  payouts_delete_confirm: 'Ин пардохтро нест кунед?',
  payouts_empty: 'Ҳоло пардохт нест',
  payout_form_submit: 'Нигоҳ доштани пардохт',
  payout_form_recipient: 'Гиранда',
  payout_form_paid_on: 'Санаи пардохт',
  payout_recipient_unnamed: 'Ном нишон дода нашудааст',
  payout_recipient_not_listed: 'Дар рӯйхати ронандагони ширкат нест',
  payout_recipient_unavailable: 'Номи гиранда дастрас нест',
  payout_recipient_loading: 'Гиранда бор шуда истодааст…',
  accounting_edit: 'Тағйир додан',
  accounting_delete: 'Нест кардан',
  accounting_more: 'Боз нишон додан',
  accounting_works_more: 'Боз корҳоро нишон додан',
  accounting_filter_reset: 'Бекор кардани интихоб',
  accounting_filter_empty: 'Аз рӯи ин интихоб сабт нест',
  accounting_filter_any: 'Ҳама',
  accounting_work_fallback: 'Кор',
  accounting_vehicle_fallback: 'Мошин',
  accounting_vehicle_missing: 'Мошин дар феҳрист ёфт нашуд',
  accounting_no_vehicle: 'Бе мошин',
  accounting_no_work: 'Бе кор',
  accounting_field_amount: 'Маблағ',
  accounting_field_currency: 'Асъор',
  accounting_field_work: 'Кор',
  accounting_field_comment: 'Шарҳ',
  accounting_choose: 'Интихоб кунед',
  accounting_form_close: 'Бекор кардан',
  expense_category_diesel: 'Сӯзишвории дизелӣ',
  expense_category_parking: 'Истгоҳ',
  expense_category_toll: 'Роҳи пулакӣ',
  expense_category_service: 'Хизматрасонӣ ва таъмир',
  expense_category_other: 'Дигар',
  // Ключи блока `WEB-2.2`. Машинный подстрочник до волны 4 (CR-008): проверке
  // не подлежит, обязательны присутствие ключа и непустота значения.
  cargo_feed_title: 'Тасмаи борҳо',
  cargo_feed_apply: 'Татбиқ кардан',
  cargo_feed_reset: 'Тоза кардан',
  cargo_feed_more: 'Боз нишон додан',
  cargo_feed_details: 'Муфассал',
  cargo_feed_company_verified: 'Ширкат санҷида шудааст',
  cargo_feed_adr: 'Бори хатарнок (ADR)',
  cargo_feed_empty: 'Эълонҳои мувофиқ нестанд',
  cargo_feed_loading_from: 'Боргирӣ аз',
  cargo_feed_loading_to: 'Боргирӣ то',
  cargo_feed_vehicles_min: 'Мошинҳо, на кам аз',
  cargo_feed_weight_from: 'Вазн аз, кг',
  cargo_feed_weight_to: 'Вазн то, кг',
  cargo_feed_body_type: 'Навъи кузов',
  cargo_feed_temperature: 'Низоми ҳарорат',
  cargo_feed_price_from: 'Нархи як мошин аз',
  cargo_feed_price_to: 'Нархи як мошин то',
  cargo_feed_currency: 'Асъори нарх',
  cargo_feed_q: 'Калимаи калидӣ',
  cargo_feed_any: 'Фарқ надорад',
  cargo_feed_yes: 'Ҳа',
  cargo_feed_no: 'Не',
  cargo_feed_cities_title: 'Шаҳрҳои равонашавӣ',
  cargo_feed_cities_total: 'Ҳамагӣ эълонҳо',
  cargo_feed_date_hint: 'СССС-ММ-РР',
  cargo_feed_my_offer: 'Пешниҳоди ширкати шумо',
  cargo_feed_listing_no_right: 'Пешниҳодро корманде мефиристад, ки ҳуқуқи гирифтани бор дорад — онро директор медиҳад',
  cargo_feed_listing_unavailable: 'Аз ин ширкат ба ин эълон ҳоло пешниҳод фиристодан мумкин нест',
  cargo_feed_listing_agree: 'Ба шартҳои шумо розӣ ҳастам',
  cargo_feed_listing_own_price: 'Нархи худам',
  cargo_feed_listing_fixed_price: 'Нарх собит аст',
  cargo_feed_listing_negotiable: 'Савдо мумкин аст',
  cargo_feed_listing_submit: 'Фиристодани пешниҳод',
  cargo_feed_listing_price_amount: 'Нархи шумо барои як мошин',
  cargo_offers_mine_title: 'Пешниҳодҳои ман',
  cargo_offers_confirm: 'Тасдиқ кардан',
  cargo_offers_withdraw: 'Бозпас гирифтан',
  cargo_offers_withdraw_confirm: 'Пешниҳод бозпас гирифта шавад? Логист дигар онро баррасӣ намекунад.',
  cargo_offers_more: 'Боз пешниҳодҳо нишон додан',
  cargo_offers_agrees: 'Розигӣ ба шартҳо',
  cargo_offers_counter: 'Нархи худ',
  cargo_offers_vehicles: 'Мошинҳо',
  cargo_offers_empty: 'Ҳоло пешниҳод нест',
  cargo_offers_price: 'Нархи як мошин',
  cargo_offers_expires: 'Ҷавоби логист то',
  cargo_offers_confirm_by: 'Тасдиқ то',
  cargo_offers_sender: 'Фиристод',
  works_to_assign_title: 'Интизори таъинот',
  works_to_assign_empty: 'Корҳои интизори таъинот нестанд',
  works_empty: 'Ҳоло кор нест',
  works_assign: 'Таъин кардан',
  works_replace: 'Иваз кардан',
  work_assignment_title: 'Таъини нақлиёт ва ронанда',
  work_assignment_tractor: 'Тягач',
  work_assignment_trailer: 'Прицеп',
  work_assignment_driver: 'Ронанда',
  work_assignment_no_trailer: 'Бе прицеп',
  work_assignment_unnamed: 'Ном нишон дода нашудааст',
  work_assignment_assign: 'Таъин кардан',
  work_assignment_replace: 'Иваз кардан',
  work_assignment_current: 'Ҳоло таъин шудаанд',
  work_assignment_assigned_at: 'Вақти таъинот',
  work_assignment_history: 'Таърихи таъинотҳо',
  work_assignment_history_empty: 'Ивазҳо набуданд',
  work_assignment_assigned_by: 'Таъин кард',
  work_assignment_replaced_by: 'Бардошт',
  work_assignment_unavailable: 'Таъинот ва иваз барои ин кор ҳоло дастрас нестанд',
  unassignable_reason_withdrawn: 'Аз феҳрист бароварда шуд',
  unassignable_reason_not_ready: 'Ба рейс омода нест',
  unassignable_reason_busy: 'Бо кори дигар банд аст',
};
